import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";

//componentes
import "./diasFeriados.css";
import Alert from "../../modal/alert";

class DiasFeriados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idcurso: "",
      tipoPlanifi: "",
      fecha: "",
      anoEscolar: "",
      tipoPlani: "",
      icursos: [],
      idiasFeriados: [],
      ianoEscolar: [],
      tipoPlanif: [],
      listaOn: false,
      fechaDF: "",

      verplanillaOn: false,
    };
  }

  limpiar = () => {
    this.setState({
      idprofesor: "",
      tipoPlanifi: "",
      fecha: "",
      listaOn: false,
      fechaDF: "",
    });
  };
  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onChange2(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.buscarFP();
  }

  guardar = () => {
    if (this.state.fechaDF.length > 0) {
      let data = new FormData();
      data.append("fechaDF", this.state.fechaDF);

      data.append("boton", "guardarDF");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/actualizarFechaAgenda.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.buscarFP();
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Dias Feriados",
              cuerpoM: res.data.variable2,
              idcurso: "",
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Dias Feriados",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Dias Feriados",
        cuerpoM:
          "Debe seleccionar una Fecha.",
      });
    }
  };

  eliminar = (e) => {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("idfecha", e);
      data.append("boton", "eliminarDF");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapiasprueba/backend/actualizarFechaAgenda.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Dias Feriados",
            cuerpoM: res.data.variable2,
          });
          this.buscarFP();
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Dias Feriados",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Dias Feriados",
        cuerpoM: "Debe existir un registro para poder eliminarlo.",
      });
    }
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  buscarFP = () => {
    let form = new FormData();
    form.append("boton", "buscarDF");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/actualizarFechaAgenda.php";
    axios.post(xurl, form, config).then((res) => {
      let xidiasFeriados = res.data.variable2;
      this.setState({
        idiasFeriados: xidiasFeriados,
      });
    });
  };

  buscarTP = (e) => {
    let form = new FormData();
    form.append("boton", "buscarTipoP");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/fechaPlanificacion.php";
    axios.post(xurl, form, config).then((res) => {
      let xitipoP = res.data.variable2;
      this.setState({
        tipoPlanif: xitipoP,
      });
    });
  };

  buscarSalones = () => {
    let data = new FormData();
    data.append("boton", "buscarSalones");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl = "https://institutobilinguelasnaciones.com/terapiasprueba/backend/materia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xicursos = res.data.variable2;

        this.setState({
          icursos: xicursos,
        });
      });
  };

  buscarAnioEscolar = () => {
    let data = new FormData();
    data.append("boton", "buscarAnioEscolar");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ianoEscolar: res.data.variable3,
        });
      }
    });
  };

  componentDidMount() {
    // this.buscarAnioEscolar();
    // this.buscarSalones();
    this.buscarFP();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>CREAR FECHA FERIADAS. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="cont-listmedi row">
            <div className="cont-personal col-12">
              <div className="contenedorcedula1f col-4">
                <input
                  className="form-control"
                  type="date"
                  name="fechaDF"
                  id="fechaDF"
                  autoComplete="off"
                  onChange={this.onChange.bind(this)}
                  value={this.state.fechaDF}
                />
              </div>
            </div>
            <div className="xcontenedorcedula1x col-12">
              <button className="boton" onClick={this.guardar.bind(this)}>
                Agregar
              </button>
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcx col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc1">DIAS FERIADOS</th>
                    <th className="titucxc3x">
                      <span className="titulo-eliminar">
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>

                {this.state.idiasFeriados.map((item, i) => {
                  return (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>
                      <td className="xcerr">
                        <span
                          className="cerrarme1"
                          onClick={this.eliminar.bind(this, item.variable1)}
                        ></span>{" "}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default DiasFeriados;
